export const COOKIE_BANNER_TAG_NAME = 'ws-cookie-banner';
export const COOKIE_BANNER_SETTING_ID = 'cookie_banner';
